export const SWIPE_CONFIDENCE_THRESHOLD = 10000;
